import { useLang } from '../../i18n';
import { ChromeStar } from '../ChromeStar';
import { FadeUp, MaskedLines } from '../motion';

export default function BrandSection() {
  const { t } = useLang();
  return (
    <section
      data-testid="brand-section"
      className="relative overflow-hidden border-t border-black/10 bg-white px-4 py-24 sm:px-8 sm:py-36 lg:px-16"
    >
      <ChromeStar className="absolute right-6 top-10 h-8 w-8 opacity-70 sm:right-16" spin />
      <FadeUp>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
          03 — {t('brand.label')}
        </p>
      </FadeUp>

      <MaskedLines
        className="mt-10 font-mono text-xl uppercase leading-[1.5] tracking-[0.14em] sm:text-4xl sm:leading-[1.4] lg:text-5xl"
        stagger={0.18}
        lines={['Vizio makes objects', 'for bad decisions.']}
      />

      <FadeUp delay={0.3}>
        <p className="mt-10 max-w-md text-sm leading-relaxed text-neutral-600">
          {t('brand.body')}
        </p>
      </FadeUp>
      <FadeUp delay={0.4}>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em]">
          {t('brand.outro')}
        </p>
      </FadeUp>
    </section>
  );
}
